import { AccordionContent, AccordionItem, AccordionTrigger } from 'components';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { MASKED_TEXT_CLASS } from 'analytics';

const TranscriptText = styled.p.attrs({
  className: `whitespace-pre-wrap text-sm leading-relaxed text-card-foreground ${MASKED_TEXT_CLASS}`,
})``;

export type TranscriptSectionMode = 'accordion' | 'standalone';

type TranscriptSectionProps = {
  transcriptText: string;
  mode?: TranscriptSectionMode;
};

export const TranscriptSection = ({
  transcriptText,
  mode = 'accordion',
}: TranscriptSectionProps) => {
  const { t } = useTranslation();

  const body = transcriptText ? (
    <TranscriptText>{transcriptText}</TranscriptText>
  ) : (
    <TranscriptText>{t('result.placeholder')}</TranscriptText>
  );

  if (mode === 'standalone') {
    return (
      <div className="pt-1" data-ph-no-autocapture>
        {body}
      </div>
    );
  }

  return (
    <AccordionItem value="transcript">
      <AccordionTrigger variant="arrow" className="text-muted-foreground" data-ph-no-autocapture>
        {t('result.transcript')}
      </AccordionTrigger>
      <AccordionContent>{body}</AccordionContent>
    </AccordionItem>
  );
};
